import React from 'react';
import PromoCodeForm from '../../../components/promo-code/promo-code-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as promoCodesActions from '../../../actions/promo-codes';
import Loading from '../../../components/loading';
import AdminItemPageContainer from '../admin-item-page-container';
import LocalizedStrings from '../../../localization/strings';

class PartnerContainer extends AdminItemPageContainer {

    getBaseUrl() {
        return '/admin/promo-codes';
    }

    fetchItem(id) {
        return this.props.actions.fetchPromoCode(id);
    }

    render() {
        const {actions, loading} = this.props;

        return (
            <div className="panel">
                <header className="panel-header">{LocalizedStrings.promoCodeEdit}</header>
                <div className="panel-body">
                    {loading
                        ? <Loading/>
                        : <PromoCodeForm submit={actions.submitPromoCode} onSuccessSubmit={this.onSuccessSubmit.bind(this)}></PromoCodeForm>
}
                </div>
            </div>
        )

    }
}

export default connect(function(state) {
    return {loading: state.promoCodes.promoCode.loading};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...promoCodesActions
        }, dispatch)
    };
})(PartnerContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/promo-codes/promo-code-container.js